import React from "react";
import { Outlet } from "react-router-dom";
import { setTitle } from "../helpers/MetaTag";

const AuthLayout = ({ metaTitle = "" }) => {
  setTitle(`Game Time HR | ${metaTitle}`);

  return (
    <>
      <Outlet />
    </>
  );
};

export default AuthLayout;
